import { IonCol, IonContent, IonGrid, IonPage, IonRow, useIonViewDidEnter } from "@ionic/react";
import React from "react";
import { Redirect, useLocation } from "react-router";
import CreditPay from "../../components/CreditPay";
import Footer from "../../components/Footer";
import { User } from "../../models/data";

interface DonateFundraiseOnlineProcessProps{
    user:User
}

const DonateFundraiseOnlineProcess:React.FC<DonateFundraiseOnlineProcessProps> = ({user}) =>{
    
    const location:any = useLocation();

    let data;
    if(location.state){
        data = location.state.data
    }
    if(data){
        return (
            <IonPage className="viewContainer">
                <IonContent>
                    <IonGrid className="mainContent">
                        <IonRow>
                                    <IonCol>
                                    <CreditPay type='donate' donateData={data} amount={data.amount} user={user}></CreditPay>
                                    </IonCol> 
                        </IonRow>
                    </IonGrid>
                <Footer></Footer>
                </IonContent>
            </IonPage>
        );
    }else{
        return(
            <Redirect to={"/account/donate"}/>
        )
    }
}

export default DonateFundraiseOnlineProcess;